import * as React from "react";
const SvgSortingUp = (props) => /* @__PURE__ */ React.createElement("svg", { stroke: "currentColor", fill: "currentColor", strokeWidth: 0, viewBox: "0 0 24 24", height: 16, width: 16, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 20h2V8h3L12 4 8 8h3z" }));
export default SvgSortingUp;
